import {ACTIONS_GAMES} from "../actions/games";

const headerDetail1 = ['観客数', '試合時間'];
const headerDetail2 = ['球審', '累審(一)', '累審(二)', '累審(三)', '外審(左)', '外審(右)'];

const tableDetail1 = [
    {
        item: [
            {
                text: '45277人'
            },
            {
                text: '3時間13分'
            },
        ]
    }
];

const tableDetail2 = [
    {
        item: [
            {
                text: '真鍋'
            },
            {
                text: '川口'
            },
            {
                text: '嶋田'
            },
            {
                text: '深谷'
            },
            {
                text: '小林'
            },
            {
                text: '牧田'
            }
        ]
    }
];

const titleTableDetail1 = {
    text: '試合詳細データ',
    pl: 'pl-16'
}
const titleTableDetail2 = {
    text: '審判',
    pl: 'pl-16'
}
const header = ['打者', '被打率', '打数', '被安打', '被本塁打', '奪三振', '与四球', '与死球'];

const header2 = ['試合', '勝利', '敗戦', '引分', '得点', '失点', '安打', '本塁打', '三振', '四球', '死球',  '併殺打', '盗塁', '失策', '打率', '防御率'];
const header3 = [
    {text: '日付', width: '10%'},
    {text: '勝敗', width: '5%'},
    {text: 'スコア', width: '8%'},
    {text: '先発', width: '12%'},
    {text: '責任投手', width: '28%'},
    {text: '球場', width: '29%'},
    {text: '開始時間', width: '8%'}
];

const table2 = [
    {
        item: [
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
        ]
    }
];

const table22 = [
    {
        item: [
            {
                text: 120
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
            {
                text: 20
            },
        ]
    }
];

const table3 = [
    {
        item: [
            {
                text: '10日（日）'
            },
            {
                text: '10日（日）'
            },
            {
                text: '1-3'
            },
            {
                text: '今村'
            },
            {
                text: '勝：今村　S：桜井'
            },
            {
                text: '甲子園'
            },
            {
                text: '13:00'
            }
        ]
    }
];

const table33 = [
    {
        item: [
            {
                text: '11日（日）'
            },
            {
                text: '10日（日）'
            },
            {
                text: '1-3'
            },
            {
                text: '今村'
            },
            {
                text: '勝：今村　S：桜井'
            },
            {
                text: '甲子園'
            },
            {
                text: '13:00'
            }
        ]
    }
];

const tab = [
    '先発情報', '対戦成績',
];

const titleTable = {
    text: 'サマリー',
    pl: 'pl-16'
};

const titleTablePitcherResult =
    [
        {
            title: '',
            width: '2.1rem'
        },
        {
            title: '選手名',
            width: '11.15rem',
        }, {
        title: '防御率',
    }, {
        title: '投球回',
    }, {
        title: '投球数',
    }, {
        title: '打者',
    }, {
        title: '被安打',
    }, {
        title: '被本塁打',
    }, {
        title: '奪三振',
    }, {
        title: '与四球',
    }, {
        title: '与死球',
    }, {
        title: '失点*',
    }, {
        title: '自責点*',
    },
    ];

export default (state = {
    headerDetail1, headerDetail2, tableDetail1,
    tableDetail2, titleTableDetail1, titleTableDetail2, header,
    header2, header3, table2, table22, table33, table3, tab, titleTable, titleTablePitcherResult
}, action) => {
    switch (action.type) {
        case ACTIONS_GAMES.GET_INFO_DETAIL_GAMES_SUCCESS:
        case ACTIONS_GAMES.GET_GAME_RESULT_GENERAL_SUCCESS:
        case ACTIONS_GAMES.GET_GAME_RESULT_OUTTING_SUCCESS:
        case ACTIONS_GAMES.GET_GAME_ANALYTICS_SUCCESS:
        case ACTIONS_GAMES.GET_INFO_GAMES_SUCCESS:
        case ACTIONS_GAMES.GET_GAME_RESULT_INNINGS_SUCCESS:
        case ACTIONS_GAMES.GET_INFO_GAME_ID_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data,
            };
        case ACTIONS_GAMES.GET_INFO_GAMES_ERROR:
        case ACTIONS_GAMES.GET_INFO_DETAIL_GAMES_ERROR:
        case ACTIONS_GAMES.GET_GAME_RESULT_GENERAL_ERROR:
        case ACTIONS_GAMES.GET_GAME_RESULT_OUTTING_ERROR:
        case ACTIONS_GAMES.GET_GAME_ANALYTICS_ERROR:
        case ACTIONS_GAMES.GET_GAME_RESULT_INNINGS_ERROR:
        case ACTIONS_GAMES.GET_INFO_GAME_ID_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
            }
        default:
            return state;
    }
};